import axios from 'axios';
import qs from 'qs';
import url from 'url';
import { APP_ID, USER_INFO, ACCESS_TOKEN } from '../commons/constants';
import { changeUpdatePassword } from '../utils/authenticate';
import getLodash from 'lodash/get';
import { getCurrentLanguage } from '../i18n';

const withLanguage = data => {
  if (data && typeof data.append === 'function') {
    if (!data.has || !data.has('lang')) data.append('lang', getCurrentLanguage());
    return data;
  }
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return { ...data, lang: getCurrentLanguage() };
  }
  return data;
};

const fetch = async (endpoint, config, authenticate, props) => {
  let token = null;
  if (authenticate) {
    token = authenticate;
  } else {
    token = localStorage.getItem(ACCESS_TOKEN);
  }
  config.data =
    typeof config.data === 'object' ? JSON.stringify(config.data) : config.data;
  config.headers = {
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'app-id': `${APP_ID}`,
  };
  const { method = 'GET', headers, data } = config;
  try {
    const instance = axios.create({
      timeout: 50000,
      headers,
    });
    const response = await instance(endpoint, {
      method,
      data,
    });

    let userInfo = localStorage.getItem(USER_INFO);
    userInfo = userInfo !== null ? JSON.parse(userInfo) : null;
    if (userInfo && userInfo.require_set_new_password === 1) {
      changeUpdatePassword();
    }

    return response;
  } catch (error) {
    if (getLodash(error, 'response.status', '') == 401) {
      // Do NOT auto-logout here for manage pages: a single endpoint 401
      // (often order.btmall.vn) was kicking users who still have a valid
      // admin/collaborator session. Surface the error to the caller instead.
      console.warn('[apiHelper] 401 Unauthorized:', endpoint);
    }

    if (getLodash(error, 'code') === 'ECONNABORTED') {
      console.log('lỗi ECONNABORTED');
      return [];
    }

    throw getLodash(error, 'response');
  }
};

const fetchV2 = async (endpoint, config, authenticate, props) => {
  let token = null;
  if (authenticate) {
    token = authenticate;
  } else {
    token = localStorage.getItem(ACCESS_TOKEN);
  }
  config.data =
    typeof config.data === 'object' ? JSON.stringify(config.data) : config.data;
  config.headers = {
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'app-id': `${APP_ID}`,
  };
  const { method = 'GET', headers, data } = config;
  try {
    const instance = axios.create({
      timeout: 50000,
      headers,
    });
    const response = await instance(endpoint, {
      method,
      data,
    });

    return response;
  } catch (error) {
    if (getLodash(error, 'response.status', '') == 401) {
      console.warn('[apiHelper] 401 Unauthorized:', endpoint);
    }

    if (getLodash(error, 'code') === 'ECONNABORTED') {
      console.log('lỗi ECONNABORTED');
      return [];
    }

    throw getLodash(error, 'response');
  }
};

const get = (endpoint, query, authenticate) => {
  if (query) {
    let parts = url.parse(endpoint, true);
    parts.query = { ...parts.query, ...query };
    parts.search = qs.stringify(parts.query);
    endpoint = url.format(parts);
  }
  return fetch(endpoint, { method: 'GET' }, authenticate);
};

const getV2 = (endpoint, query, authenticate) => {
  if (query) {
    let parts = url.parse(endpoint, true);
    parts.query = { ...parts.query, ...query };
    parts.search = qs.stringify(parts.query);
    endpoint = url.format(parts);
  }
  return fetchV2(endpoint, { method: 'GET' }, authenticate);
};

const post = (endpoint, data, authenticate) => {
  return fetch(endpoint, { method: 'POST', data: withLanguage(data) }, authenticate);
};

const postV2 = (endpoint, data, authenticate) => {
  return fetchV2(endpoint, { method: 'POST', data: withLanguage(data) }, authenticate);
};

const put = (endpoint, data, authenticate) => {
  return fetch(endpoint, { method: 'PUT', data: withLanguage(data) }, authenticate);
};

const patch = (endpoint, data, authenticate) => {
  return fetch(endpoint, { method: 'PATCH', data: withLanguage(data) }, authenticate);
};

const del = (endpoint, data, authenticate) => {
  return fetch(endpoint, { method: 'DELETE', data: withLanguage(data) }, authenticate);
};

const uploadFile = async (endpoint, data) => {
  let token = localStorage.getItem(ACCESS_TOKEN);
  let headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'multipart/form-data',
    'app-id': `${APP_ID}`,
  };
  try {
    if (data && typeof data.append === 'function' && !data.has('lang')) {
      data.append('lang', getCurrentLanguage());
    }
    const instance = axios.create({
      timeout: 10000,
      headers,
    });
    const response = await instance(endpoint, {
      method: 'POST',
      data,
    });
    return response;
  } catch (error) {
    if (getLodash(error, 'response.status', '') == 401) {
      console.warn('[apiHelper] 401 Unauthorized (upload):', endpoint);
    }
    throw getLodash(error, 'response');
  }
};

export { get, getV2, put, post, postV2, patch, del, uploadFile };
